import { Link } from "react-router-dom"
import { Container, Typography, Card, CardContent, Box, CircularProgress } from "@mui/material"
import { useSelector } from "react-redux"
import { specialFont } from "../../Infrastructure/Theme/fontFamily"
import { blogListSx } from "./styles"

export default function BlogList() {
  const { blogData, loading, error } = useSelector((state) => state.blog)
  const userData = useSelector((state) => state.userData.data)
  const isEducator = userData?.is_educator

  if (loading) {
    return (
      <Box sx={blogListSx.loadingBox}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={blogListSx.errorContainer}>
        <Typography color="error">Error loading blog: {error.message || error}</Typography>
      </Container>
    )
  }

  const filteredBlog = blogData?.filter(blog =>
    blog.visible && (!blog.private || (blog.private && isEducator === true))
  );

  return (
    <Container maxWidth="md" sx={blogListSx.mainContainer}>
      <Typography sx={blogListSx.title} gutterBottom fontFamily={specialFont} color={'primary.main'}>
        Blog
      </Typography>
      <Box sx={blogListSx.gridBox}>
        {filteredBlog?.length > 0 ? (
          filteredBlog.map((blog) => (
            <Card
              key={blog?.id}
              component={Link}
              to={blog?.url}
              sx={blogListSx.card}
            >
              <CardContent>
                <Typography
                  className="blog-title"
                  sx={blogListSx.blogTitle}
                >
                  {blog?.title}
                </Typography>
                <Box
                  sx={blogListSx.contentBox}
                  dangerouslySetInnerHTML={{ __html: blog?.content }}
                />
              </CardContent>
            </Card>
          ))
        ) : (
          <Typography variant="body1">No blog available</Typography>
        )}
      </Box>
    </Container>
  )
}